<template>
<div id="app-container">
      <div class="header-bar">
  <img  src="./assets/Banner.png"/>
</div>
<Suspense>
  <GameScreen msg="Welcome to Your Vue.js App" :orientation="window.height > window.width ? 'portrait' : 'landscape'"/>
    </Suspense>
</div>

  <div v-if="window.width > 768" class="background" :style="{height: window.height, width: window.width}"/>
</template>

<script>
import GameScreen from './components/GameScreen.vue'

export default {
  name: 'App',
  data(){
    return {
      window: {
        width: 0,
        height: 0
      }
    }
  },
  created(){
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  unmounted(){
    window.removeEventListener('resize', this.handleResize);
  },
  components: {
    GameScreen
  },
  methods:{
    handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
  }
}
</script>

<style>

@font-face {
  font-family: 'gomarice_rockin_record';
  src: url('./assets/fonts/gomarice_rockin_record.ttf');
}

@font-face {
  font-family: 'Qarmic Sans';
  src: url('./assets/fonts/Qarmic sans.ttf');
}

#app-container {
  background: rgba(255, 255, 255, 0.932);
  height: 100%;
  width:100%;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  display: flex;

  scrollbar-width: 0px;
  font-size: 1em;
  background-color: rgba(0,0,0,0);
    font-family: 'Qarmic Sans';
  font-weight:bold;

}

#app {
  overflow-x:hidden;
  height:100%;
  
}

body {
     background: black;
    background-size: 400%;
    justify-content: center;
    align-items: center;
    height: 100vh;
    box-sizing: border-box;
    width: 100vw;
    margin:0;
      overflow-y: auto;
  overflow-x: hidden;
    background-color: #dcc508fe;
z-index: 0;


}

html {
      user-select: none;

}
img {
  height: 100%;
  max-height: 30vh;
  max-width: 90vw;
  padding: 20px;
  box-sizing: border-box;
}

.header-bar {
  flex: 1;
  flex-grow: 0;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: black;
  color:white;
  z-index: 1;
}

.background {
  height: 100%;
  width: 400%;
  position: absolute;
  background-image: url('./assets/background.png');
  background-repeat: repeat;
  background-size: 5%;
  z-index: -1;
  opacity: 0.2;
  left: 0%;
  top:0;
  animation: move-background 10s linear infinite;

}

@keyframes move-background {
  0% {
    left: -100%;

  }
  100% {
    left: 0%;
    bottom: 0%;
  }
}
</style>
